var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardListStatusIcon3 = function SvgNewcsDashboardListStatusIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_list_status_icon3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M326 434h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 336"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_list_status_icon3_svg__a)",
    transform: "translate(-326 -434)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#13c2c2",
    d: "M331.614 445a.94.94 0 0 1-.653-.26l-3.693-3.556a.867.867 0 0 1 0-1.257.95.95 0 0 1 1.305 0l3.04 2.927 5.809-5.593a.947.947 0 0 1 1.305 0 .866.866 0 0 1 0 1.256l-6.462 6.223a.94.94 0 0 1-.651.26",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardListStatusIcon3;